export default class Label {
  constructor(box21_api) {
    this.api = box21_api;
  }

  async all() {
    let formData = new FormData();
    formData.append("project_id", sessionStorage.getItem("project_id"));
    let items = await this.api.post_with_token(
      "/available-model-parameters",
      formData
    );
    if (items) {
      return items.map((item) => {
        if (item.options && typeof item.options === "string") {
          item.options = JSON.parse(item.options);
        }
        return item;
      });
    } else {
      return items;
    }
  }
}
